import angular from 'angular';
import ngAnimate from 'angular-animate';
import ProgressBarDirective from './progress-bar-directive';
import bootstrap from 'angular-ui-bootstrap';
import i18n from '../i18n';

/**
* @ngdoc module
* @name akamai.components.progress-bar
*
* @guideline https://design.akamai.com/components/progress-bar/
*
* @description
* A progress bar directive that is focused on providing
* feedback on the progress of a workflow or action.
* This component could be presented in a pop-up window, or inline within a component or page.
*
* @example index.html
* {% raw %}
* <akam-progress-bar value="currentValue" max="maxValue" state="state" animate="{{ animate }}"
*                    label="label" additional-info="additional info"
*                    label-align="{{ labelAlign }}"></akam-progress-bar>
* {% endraw %}
*
* @example index.js
* var controllerFunction = function($scope) {
*   $scope.currentValue = '45';
*   $scope.maxValue = '100';
*   $scope.state = '';
*   $scope.animate = 'true';
*   $scope.label = 'Downloading';
*   $scope.additionalInfo = '45% Complete';
*   $scope.labelAlign = 'left';
* };
* controllerFunction.$inject = ['$scope'];
* var app = angular.module("progressBarDemo",
*   ["akamai.components.progress-bar"]);
*
* app.controller("Ctrl", controllerFunction);
*/
export default angular.module('akamai.components.progress-bar', [
  ngAnimate,
  bootstrap,
  i18n.name
])

/**
* @ngdoc directive
*
* @name akamProgressBar
*
* @description Creates a determinate progress bar control
*
* @restrict E
*
* @param {number} value The current value of progress completed.
*
* @param {number} [max=100] A number that specifies the total value of progress. When `value`
* equals `max`, the process is completed.
*
* @param {string} state='inprogress' The current state of the progress bar.
* When an error occurs, change the state to `error` and
* update the `label` to an appropriate error message.
* When the progress is completed, state will automatically change to `completed`.
* Possible states are `inprogress`, `completed` and `error`
*
* @param {string|TranslateKey} [label] The descriptive text under the progress bar.
* If omitted, no text will be displayed under the progress bar.
*
* @param {string} label-align The label position under the progress bar.
* Possible values are `left`, `center` and `right`.
*
* @param {boolean} [animate=false] When animate is true, the progress bar is animated
* with moving strips and updated in real-time.
*/
.directive('akamProgressBar', ProgressBarDirective);
